import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';
import ProductImage from '../../../../components/product-image/product-image';
import ProductLinks from '../product-links/product-links';

import { getNormalizedProductType } from '../../../../shared/utils/product/product';
import { ProductTypeProp } from '../../../../shared/utils/prop-types/prop-types';
import { shopAction } from '../../utils/analytics';
import { getCategoryURL } from '../../utils/category-page-utils';

import { PRODUCT_TYPES } from '../../../../shared/constants/products';

import './category-row.scss';

function CategoryRow(props) {
  const {
    parentCategory,
    category,
    productType,
    showStaggeredURL = false
  } = props;

  if (typeof category !== 'object' || category === null) {
    return null;
  }

  const normalizedProductType = getNormalizedProductType(productType);

  return (
    <>
      <div styleName="heading">
        <ProductImage
          ariaLabel={category?.thumbnail?.altText || category?.name}
          height={125}
          imageUrl={category?.thumbnail?.url}
          styleName={normalizedProductType?.toLowerCase()}
          width={125}
        />
        <div styleName="text-container">
          <h2>{category.name}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: category?.description }}
            styleName="description"
          />
          <Link
            onClick={() =>
              shopAction({ category, parentCategory, productType })
            }
            to={getCategoryURL(category.catalogURL, showStaggeredURL)}
          >
            {normalizedProductType === PRODUCT_TYPES.ACCESSORIES
              ? category.linkText.toLowerCase()
              : category.linkText}
          </Link>
        </div>
      </div>
      {Array.isArray(category.products) && <ProductLinks category={category} />}
    </>
  );
}

CategoryRow.propTypes = {
  category: PropTypes.object,
  parentCategory: PropTypes.object,
  productType: ProductTypeProp,
  showStaggeredURL: PropTypes.bool
};

export default CategoryRow;
